// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsHeader-cls1_RlR","cls2":"NewsHeader-cls2_JL9 NewsHeader-cls1_RlR"};